import { storeAnnotation } from "mobx/dist/internal"
import { useEffect } from "react"
import { useImageUload } from "../customHooks/useImageUpload"
import { fetchProfileImageUrl } from "../services/HelperService"
import { compressImage } from "../services/ImageCompressionService"
import { ProfileStore } from "../stores/ProfileStore"

export const MainProfileImage = (props:{src: string, uid: string, store: ProfileStore}) => {

    const {picUrlState, imgInputRef, handleSelection, selectImage, removePic, setPicUrlState} = useImageUload(props.src)

    useEffect(()=>{
        async function action(){
            let picUrl = await fetchProfileImageUrl(props.uid, 0)
            setPicUrlState(picUrl?? null)
        }

        action()
    },[])

    async function handleImageSelection(e:any){
        const file = handleSelection(e)
        const compressedLoad = await compressImage(file)
        props.store.setPicData(compressedLoad, 0)
    }

    function deletePic(){
        removePic()
        props.store!.deletePic(0)
    }
    
    return (
        <div className='user-profile-sub-wrapper' >
                {picUrlState != null ? <i className="material-icons"
                onClick={deletePic}
                    style={{
                        fontSize: 25,
                        zIndex: 10,
                        position: 'absolute',
                        top: 5,
                        right: 5
                    }}>clear</i>: null}
            <input ref={imgInputRef} type="file" accept="image/*" alt="" hidden onChange={handleImageSelection} />
            {picUrlState != null ? <img className='user-profile' src={picUrlState!} alt="" /> :
                <i className="material-icons-outlined"
                    onClick={selectImage}
                    style={{
                        fontSize: 25,
                        zIndex: 10,
                        width: 130,
                        height: 30,
                        textAlign: 'center'
                    }}>add</i>
            }
            
        </div>
    )

}